import * as React from 'react';
import { GenericMultiSelectModal } from '../../misc/components/queryTable/MultiSelectModal';
import { GenericNumberRangeModal } from "../../misc/components/queryTable/NumberRangeModal";
import { QueryFilter } from '../../misc/api/apiTypes';
import * as Shared from '../SubjectsShared';
import { GenderTableFilter } from './GenderTableFilter';
import { QueryTableState } from '../../misc/components/queryTable/Hooks/UseQueryTable';
import { RandomizationTableFilter } from './RandomizationTableFilter';
import { DataItemConfiguration } from 'webportalclient';
import { ConfigurableDataItemIds } from '../../misc/api/ApiConfigurableDataItems';
import { WebPortalLegacyClientInternal } from '../../misc/api/WebPortalTokenClient';

const getColumnName = ((fieldsConfigurations: Array<DataItemConfiguration>, itemId: ConfigurableDataItemIds) => {
    if (fieldsConfigurations === null)
        return '';

    return fieldsConfigurations.find(x => x.configurableDataItemId === itemId).displayText;
})

const FilterModals = (legacyClient: WebPortalLegacyClientInternal, fieldsConfigurations: DataItemConfiguration[], queryState: QueryTableState, selectedFilterModal: string, filterModalOnClose: (values: QueryFilter[]) => void, filterModalOnClear: (member: string) => void): JSX.Element => {
    switch (selectedFilterModal) {
        case (Shared.SiteNumberFilterMember):
            return <GenericMultiSelectModal
                query={queryState.query}
                member={Shared.SiteNumberFilterMember}
                header="Site Number"
                onClose={filterModalOnClose}
                onClear={filterModalOnClear}
                onGet={legacyClient.getSubjects.bind(legacyClient)}
            />;
        case (Shared.SubjectNumberFilterMember):
            return <GenericMultiSelectModal
                query={queryState.query}
                member={Shared.SubjectNumberFilterMember}
                header={getColumnName(fieldsConfigurations, ConfigurableDataItemIds.SubjectId)}
                onClose={filterModalOnClose}
                onClear={filterModalOnClear}
                onGet={legacyClient.getSubjects.bind(legacyClient)}
            />;
        case (Shared.SubjectRandomizationNumberFilterMember):
            return <RandomizationTableFilter
                query={queryState.query}
                onClose={filterModalOnClose}
                onClear={filterModalOnClear}
            />;
        case (Shared.SubjectGenderFilterMember):
            return <GenderTableFilter
                query={queryState.query}
                onClose={filterModalOnClose}
                onClear={filterModalOnClear}
            />;
        case (Shared.SubjectPopulationGroupFilterMember):
            return <GenericMultiSelectModal
                query={queryState.query}
                member={Shared.SubjectPopulationGroupFilterMember}
                header={getColumnName(fieldsConfigurations, ConfigurableDataItemIds.SubjectPopulationGroup)}
                onClose={filterModalOnClose}
                onClear={filterModalOnClear}
                onGet={legacyClient.getSubjects.bind(legacyClient)}
            />;
        case (Shared.SubjectAgeFilterMember):
            return <GenericNumberRangeModal
                query={queryState.query}
                member={Shared.SubjectAgeFilterMember}
                header={getColumnName(fieldsConfigurations, ConfigurableDataItemIds.SubjectAge)}
                onClose={filterModalOnClose}
                onClear={filterModalOnClear}
            />;
        default:
            return null;
    }
}

export default FilterModals;
